import React from 'react';
import { Tag, Typography } from 'antd';
import { snakeCase } from 'lodash-es';
import ArrowUpOutlined from '@ant-design/icons/ArrowUpOutlined';
import { formatAmount } from 'utils';
import dayjs from 'dayjs';
import JumpLink from 'components/JumpLink';

export const TABLE_RENDER_TYPES = {
  TAG: (value) => (
    <Tag>
      {value}
    </Tag>
  ),
  DATE: (value) => (value ? dayjs(value).format('MMM D, hh:mm A') : null),
  // Todo: use code after removing bootstrap (it style conflict)
  CODE: (value) => <Typography.Text strong>{value}</Typography.Text>,
  DOLLAR: (value) => <Typography.Text strong>{formatAmount(value)}</Typography.Text>,
  CENT: (value) => <Typography.Text strong>{formatAmount(value, { isCent: true })}</Typography.Text>,
  MERCHANT_LINK: ({ id, name }) => (
    <JumpLink href={`/console/restaurants/${id}`} text={name} maxWidth={110} />
  ),
  CUSTOMER_LINK: ({ name, id }) => (
    <JumpLink href={`/console/customers/${id}`} text={name} />
  ),
  // Order table: black label + only purple arrow is clickable (layout constrained to avoid overlap)
  MERCHANT_LINK_ORDER_TABLE: ({ id, name }) => (
    <span
      className="inline-flex items-center overflow-hidden"
      style={{ maxWidth: '100%', minWidth: 0 }}
    >
      <Typography.Text
        style={{ color: 'rgba(0, 0, 0, 0.88)', minWidth: 0, maxWidth: 110 }}
        ellipsis={{ tooltip: name }}
        className="mr-1 shrink min-w-0"
      >
        {name}
      </Typography.Text>
      <Typography.Link
        href={`/console/restaurants/${id}`}
        target="_blank"
        onClick={(e) => { e.isLink = true; }}
        className="shrink-0"
      >
        <ArrowUpOutlined className="rotate-45" />
      </Typography.Link>
    </span>
  ),
  CUSTOMER_LINK_ORDER_TABLE: ({ name, id }) => (
    <span
      className="inline-flex items-center overflow-hidden"
      style={{ maxWidth: '100%', minWidth: 0 }}
    >
      <Typography.Text
        style={{ color: 'rgba(0, 0, 0, 0.88)', minWidth: 0 }}
        ellipsis={{ tooltip: name }}
        className="mr-1 shrink min-w-0"
      >
        {name}
      </Typography.Text>
      <Typography.Link
        href={`/console/customers/${id}`}
        target="_blank"
        onClick={(e) => { e.isLink = true; }}
        className="shrink-0 ml-1"
      >
        <ArrowUpOutlined className="rotate-45" />
      </Typography.Link>
    </span>
  ),
};

export function generateColumns(cols) {
  return cols.map((col) => {
    if (typeof col === 'string') {
      const key = snakeCase(col);
      const title = col;
      const dataIndex = key;
      return {
        title: title?.toUpperCase(),
        dataIndex,
        key,
      };
    }

    // eslint-disable-next-line prefer-const
    let {
      title, key, render, filters, onFilter, width, align, fixed, sorter, hidden, onCell, ellipsis,
    } = col;

    key = key || snakeCase(title);

    return {
      title: title?.toUpperCase?.() ?? title,
      key,
      render,
      dataIndex: key,
      filters,
      onFilter,
      width,
      align,
      fixed,
      sorter,
      hidden,
      onCell,
      ellipsis,
    };
  });
}
